import {create} from 'zustand'
import {devtools} from 'zustand/middleware'

import { 
    getPrimaryList, 
    getSignatureCard,
    putSignatureCard,
    postTgSignature,
} from './api'

import { 
    type FilterParametersType,
    type SignatureCardUpdateType,

    IContractsSignatureActions, IContractsSignatureState, 
    IPrimaryListQueryResult, 
} from './state.types'
import { createLatestRequestController } from '../latest-request'


/** Начальное состояние */
export const initialStateContractsSignature: IContractsSignatureState = {
    isLoadingCard: false,
    
    primaryList: {
        isLoading: false,

        items: [] as IPrimaryListQueryResult[],
        pageSize: 0,
        currentPage: 0,

        totalCount: 0,
        new: 0,
        delayedCall: 0,
        execution: 0,
        canceled: 0,
        notClient: 0,
        ignore: 0,
        refund: 0,
    },

    signatureCard: {
        commentCallCenter: '',
        contractStatusCallCenterID: 0,
        contractStatusCallCenterName: '',
        dateNextCall: '',
        timeNextCall: '',
    }
}

const signatureListRequest = createLatestRequestController()
const signatureCardRequest = createLatestRequestController()


/** Хранилище страницы - Договора на подпись */
export const useContractsSignature = create<IContractsSignatureState & IContractsSignatureActions>()(devtools((set) => ({
    ...initialStateContractsSignature,

    /** Сброс хранилища, до начального состояния */
    clearStateContractsSignature: () => {
        signatureListRequest.invalidate()
        signatureCardRequest.invalidate()
        set(initialStateContractsSignature)
    },

    /** Сброс анкеты договора, до начального состояния */
    clearStateSignatureCard: () => {
        signatureCardRequest.invalidate()
        set(() => ({
            signatureCard: {
                commentCallCenter: '',
                contractStatusCallCenterID: 0,
                contractStatusCallCenterName: '',
                dateNextCall: '',
                timeNextCall: '',
            }
        }))
    },



    /** Список, Договора на подпись - Физические лица */
    actionGetPrimaryList: async (pageNumber: number, search: string, filter?: FilterParametersType, isShowLoading: boolean = true) => {
        const request = signatureListRequest.start()
        set((state) => ({ 
            primaryList: { 
                ...state.primaryList, 
                isLoading: isShowLoading 
            } 
        }))


        /** Выполняем запрос */
        const response = await getPrimaryList(pageNumber, search, filter, !isShowLoading, request.signal)
        if (!request.isCurrent()) return response
        request.finish()

        // Проверка статуса
        if (response.status === 200) {
            set((state) => ({
                primaryList: {
                    ...state.primaryList,

                    items: response.data!.items,
                    pageSize: response.data!.pageSize,
                    currentPage: response.data!.currentPage,

                    totalCount: response.data!.totalCount,
                    new: response.data!.new,
                    delayedCall: response.data!.delayedCall,
                    execution: response.data!.execution,
                    canceled: response.data!.canceled,
                    notClient: response.data!.notClient,
                    ignore: response.data!.ignore,
                    refund: response.data!.refund,
                }
            }))
        }

        set((state) => ({ 
            primaryList: { 
                ...state.primaryList, 
                isLoading: false 
            } 
        }))

        return response
    },
    /** Получение данных по анкете договора */
    actionGetSignatureCard: async (contractID: number) => {
        const request = signatureCardRequest.start()
        set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await getSignatureCard(contractID, request.signal)
        if (!request.isCurrent()) return response
        request.finish()

        // Проверка статуса
        if (response.status === 200) {
            set((state) => ({
                signatureCard: {
                    ...state.signatureCard,
                    
                    commentCallCenter: response.data!.commentCallCenter,
                    contractStatusCallCenterID: response.data!.contractStatusCallCenterID,
                    contractStatusCallCenterName: response.data!.contractStatusCallCenterName,
                    dateNextCall: response.data!.dateNextCall,
                    timeNextCall: response.data!.timeNextCall,
                }
            }))
        }

        set({isLoadingCard: false})

        return response
    },
    /** Обновление данных по анкете договора */
    actionPutSignatureCard: async (contractID: number, data: SignatureCardUpdateType) => {
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const response = await putSignatureCard(contractID, data)

        // Проверка статуса
        if (response.status === 200) {}

        // set({isLoadingCard: false})

        return response
    },


    /** Отправка информации в Telegram канал (ИКТ - Договора на подпись) */
    actionPostTgSignature: async (contractID: number) => {
        // set((state) => ({applications: {...state.applications, isLoading: true}}))
        // set({isLoadingCard: true})

        /** Выполняем запрос */
        const responce = await postTgSignature(contractID)
        // if (res.status !== 200) set({ error: {type: res.status === 500 ? 'error' : 'warning', message: res.message} })

        // if (res.message === 'OK') set({ error: null })

        // set((state) => ({applications: {...state.applications, isLoading: false}}))
        // set({isLoadingCard: false})

        return responce
    },

}), {name: 'StateContractsSignature'}))